// Constantes partagées entre toutes les marques

// Configuration du calendrier
export const CALENDAR_CONFIG = {
  daysOfWeek: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
  locale: 'fr-FR',
  dateFormat: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  },
  monthFormat: { month: 'long' },
};

// Formats
export const FORMATS = {
  date: 'YYYY-MM-DD',
  time: 'HH:mm',
  dateDisplay: 'DD / MM / YYYY',
  timeDisplay: 'HH : mm',
};

// Configuration des icônes
export const ICONS = {
  chevronLeft: 'material-symbols-light:chevron-left',
  chevronRight: 'material-symbols-light:chevron-right',
};

// Configuration des paramètres URL
export const URL_PARAMS = {
  zendeskId: 't',
  origin: 'o',
  brand: 'brand',
};

// Configuration des champs de formulaire
export const FORM_FIELDS = {
  carModel: 'carmodel',
  zendeskId: 'id_zendesk',
  dateSelected: 'date-selected',
  hourSelected: 'hour-selected',
  comment: 'comment',
  marqueRdv: 'marquerdv',
  origin: 'origin',
  slug: 'slug',
};

// Mapping des origines
export const ORIGIN_MAPPING = {
  a: 'ordv-sms-nurturing-rs',
  b: 'ordv-sms-user',
  c: 'ordv-sms-registered-project',
  d: 'ordv-sms-init-information',
  e: 'ordv-sms-init-project',
};
